import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=0815d244"
import script from "../scripts/ResetPassword.js?vue&type=script&lang=js&external"
export * from "../scripts/ResetPassword.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports